module.exports = __webpack_public_path__ + "static/media/4ODA12.dc5e2341.jpg";